/* EXC floating cart button (snippets/exc-floating-cart.liquid)
   The theme's <cart-link> keeps the number itself up to date. This only keeps
   data-count in step so the red count badge hides on an empty cart. */
import Cart from 'cart-store';

const buttons = document.querySelectorAll('.exc-floating-cart');

if (buttons.length) {
  Cart.subscribe((state) => {
    const count = String(window.excCart ? window.excCart.count(state.cart) : state.cart.item_count);
    buttons.forEach((el) => {
      if (el.dataset.count !== count) el.dataset.count = count;
    });
  });
}
